// src/services/badgeService.js
// Sets the app icon badge.
//
// Uses @capawesome/capacitor-badge rather than a custom plugin: the hand-rolled
// one compiled fine but Capacitor never registered it, and this one is
// maintained and registers itself.
//
// Badging needs no permission of its own on iOS - it is covered by the
// notification authorisation the app already has.

import { Capacitor } from '@capacitor/core';
import { Badge } from '@capawesome/capacitor-badge';

/**
 * Set the app icon badge.
 * @param {number} count - 0 clears it.
 */
export const setBadge = async (count) => {
  if (Capacitor.getPlatform() !== 'ios') return;

  const n = Math.max(0, Number(count) || 0);

  try {
    if (n === 0) {
      await Badge.clear();
    } else {
      await Badge.set({ count: n });
    }
  } catch (err) {
    // Never let a cosmetic badge break anything upstream.
    console.warn('[Badge] Failed to set badge:', err);
  }
};
